import { InputOption, KeyValue } from "../../shared/models/Input";

export interface DataForm {
	salarie: InputOption,
	heuresmois: InputOption,
	transport: InputOption,
	restaurant: InputOption,
	cpmois: InputOption,
	debutconges: InputOption,
	finconges: InputOption,
	rttmois: InputOption,
	debutrtt: InputOption,
	finrtt: InputOption,
	cprestant: InputOption,
	rttrestant: InputOption,
	reglement: InputOption,
	dateDepart: InputOption,
	dateDernier: InputOption,
	dateNotif: InputOption,
	refusCdiSuiteCdd: InputOption,
	motif: InputOption,
	divers: InputOption,
	motifLicenciement: InputOption,
	dateLicenciement: InputOption,
	typePreavis: InputOption,
	debutPreavis: InputOption,
	finPreavis: InputOption,
	montantIndemnite: InputOption,
	dateSignature: InputOption,
	autreMotif: InputOption
}

export const dataFormBase: DataForm = {
	salarie: {
		vmodel: "",
		label: "Salarié",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	heuresmois: {
		vmodel: "",
		label: "Heures travaillées du mois",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	transport: {
		vmodel: "",
		label: "Remboursement transport",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	restaurant: {
		vmodel: "",
		label: "Titres restaurant",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	cpmois: {
		vmodel: "",
		label: "CP pris du mois",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	debutconges: {
		vmodel: "",
		label: "Début de congés",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		minDate: "1990-01-01",
		display: ""
	},
	finconges: {
		vmodel: "",
		label: "Fin de congés",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		minDate: "1990-01-01",
		display: ""
	},
	rttmois: {
		vmodel: "",
		label: "RTT pris du mois",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	debutrtt: {
		vmodel: "",
		label: "Début de RTT",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		minDate: "1990-01-01",
		display: ""
	},
	finrtt: {
		vmodel: "",
		label: "Fin de RTT",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		minDate: "1990-01-01",
		display: ""
	},
	cprestant: {
		vmodel: "",
		label: "CP restant à payer (reliquat + droits ouverts)",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	rttrestant: {
		vmodel: "",
		label: "RTT restant à payer",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	reglement: {
		vmodel: "",
		label: "Mode de règlement",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	dateDepart: {
		vmodel: "",
		label: "Date de départ",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		minDate: "1990-01-01",
		display: ""
	},
	dateDernier: {
		vmodel: "",
		label: "Date dernier jour travaillé / payé",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		minDate: "1990-01-01",
		display: ""
	},
	dateNotif: {
		vmodel: "",
		label: "Date de notification de la rupture",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		minDate: "1990-01-01",
		display: ""
	},
	refusCdiSuiteCdd: {
		vmodel: "",
		label: "Refus de proposition CDI suite CDD",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	motif: {
		vmodel: "",
		label: "Motif de départ",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	divers: {
		vmodel: "",
		label: "Divers",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 400,
		height: 229
	},
	motifLicenciement: {
		vmodel: "",
		label: "Motif du licencement",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		required: true,
		disabled: false
	},
	dateLicenciement: {
		vmodel: "",
		label: "Date de l'entretien préalable au licenciement",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		required: true,
		disabled: false,
		showToolTip: true,
		minDate: "1990-01-01",
		display: ""
	},
	typePreavis: {
		vmodel: "",
		label: "Type de préavis",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		required: true,
		disabled: false
	},
	debutPreavis: {
		vmodel: "",
		label: "Début préavis",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		required: true,
		disabled: false,
		minDate: "1990-01-01",
		display: ""
	},
	finPreavis: {
		vmodel: "",
		label: "Fin préavis",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		required: true,
		disabled: false,
		minDate: "1990-01-01",
		display: ""
	},
	montantIndemnite: {
		vmodel: "",
		label: "Montant de l'indemnité",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		required: true,
		disabled: false
	},
	dateSignature: {
		vmodel: "",
		label: "Date de signature du CERFA",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		required: true,
		disabled: false,
		showToolTip: true,
		minDate: "1990-01-01",
		display: ""
	},
	autreMotif: {
		vmodel: "",
		label: "Motif",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		required: true,
		disabled: false,
		height: 229
	}
};

export const listeBooleenBase: KeyValue[] = [
	{
		key: "0",
		value: "Non"
	},
	{
		key: "1",
		value: "Oui"
	}
];

export const listeReglementBase: KeyValue[] = [
	{
		key: "2",
		value: "Chèque"
	},
	{
		key: "3",
		value: "Virement"
	}
];

export const listeMotifLicenciementBase: KeyValue[] = [
	{
		key: "11",
		value: "Licenciement suite à liquidation judiciaire ou à redressement"
	},
	{
		key: "12",
		value: "Licenciement suite à fermeture définitive de l'établissement"
	},
	{
		key: "14",
		value: "Licenciement pour motif éco"
	},
	{
		key: "15",
		value: "Licenciement pour fin de chantier"
	},
	{
		key: "20",
		value: "Licenciement pour autre motif"
	},
	{
		key: "86",
		value: "Licenciement convention CATS"
	},
	{
		key: "87",
		value: "Licenciement pour faute grave"
	},
	{
		key: "88",
		value: "Licenciement pour faute lourde"
	},
	{
		key: "89",
		value: "Licenciement pour force majeure"
	},
	{
		key: "91",
		value: "Licenciement pour inaptitude physique"
	},
	{
		key: "92",
		value: "Licenciement pour inaptitude physique d'origine professionnelle"
	},
	{
		key: "93",
		value: "Licenciement suite à décision d'une autorité administrative"
	}
];



// WEBPACK FOOTER //
// ./src/components/sortieSalarie/sortieSalarie.model.ts